import iconA from "tui-image-editor/dist/svg/icon-a.svg";
//import iconB from "tui-image-editor/dist/svg/icon-b.svg";
import iconC from "tui-image-editor/dist/svg/icon-c.svg";
import iconD from "tui-image-editor/dist/svg/icon-d.svg";
import bg from "./bg.png";

const WhiteTheme = {
  "common.bi.image": "",
  "common.bisize.width": "0px",
  "common.bisize.height": "0px",
  "common.backgroundImage": bg,
  "common.backgroundColor": "#fff",
  "common.border": "0px solid #c1c1c1",

  // header
  "header.backgroundImage": "none",
  "header.backgroundColor": "transparent",
  "header.border": "0px",

  // load button
  "loadButton.backgroundColor": "transparent",
  "loadButton.border": "0px solid #ddd",
  "loadButton.color": "transparent",
  "loadButton.fontFamily": "NotoSans, sans-serif",
  "loadButton.fontSize": "0px",

  // download button
  "downloadButton.backgroundColor": "transparent",
  "downloadButton.border": "0px solid #fdba3b",
  "downloadButton.color": "transparent",
  "downloadButton.fontFamily": "NotoSans, sans-serif",
  "downloadButton.fontSize": "0px",

  // main icons
  "menu.normalIcon.path": iconC,
  "menu.normalIcon.name": "icon-c",
  "menu.activeIcon.path": iconA,
  "menu.activeIcon.name": "icon-a",
  "menu.iconSize.width": "20px",
  "menu.iconSize.height": "20px",

  // submenu primary color
  "submenu.backgroundColor": "transparent",
  "submenu.partition.color": "#858585",

  // submenu icons
  "submenu.normalIcon.path": iconA,
  "submenu.normalIcon.name": "icon-a",
  "submenu.activeIcon.path": iconD,
  "submenu.activeIcon.name": "icon-d",
  "submenu.iconSize.width": "32px",
  "submenu.iconSize.height": "32px",

  // submenu labels
  "submenu.normalLabel.color": "#858585",
  "submenu.normalLabel.fontWeight": "normal",
  "submenu.activeLabel.color": "#000",
  "submenu.activeLabel.fontWeight": "normal",

  // checkbox style
  "checkbox.border": "1px solid #ccc",
  "checkbox.backgroundColor": "#fff",

  // rango style
  "range.pointer.color": "#333",
  "range.bar.color": "#ccc",
  "range.subbar.color": "#606060",
  "range.value.color": "#000",
  "range.value.fontWeight": "normal",
  "range.value.fontSize": "11px",
  "range.value.border": "0",
  "range.value.backgroundColor": "#f5f5f5",
  "range.title.color": "#000",
  "range.title.fontWeight": "lighter",

  // colorpicker style
  "colorpicker.button.border": "1px solid #cbcbcb",
  "colorpicker.title.color": "#000"
};

export default WhiteTheme;



// WEBPACK FOOTER //
// ./src/components/Reveal/ImageEditor/theme/WhiteTheme.js